module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cQf3y"))).then(() => parcelRequire('9Lwss'));